import apis from './apis';

/**
 * Start a review of an EXISTING document (a generated draft or an uploaded
 * file) against a playbook, without re-uploading. The backend resolves the
 * document's blob path server-side and creates a normal review session, so the
 * result opens in /reviews/<session_uuid> like any other review.
 */

export interface StartReviewFromDocResult {
  session_uuid: string;
  playbook_uuid: string;
  status: string;
  document_count?: number;
  error?: string;
}

export interface StartReviewFromDocOptions {
  name?: string;
  language?: string | null;
  jurisdiction?: string[];
}

export async function startReviewFromDraft(
  draftUuid: string, playbookUuid: string, opts: StartReviewFromDocOptions = {},
): Promise<StartReviewFromDocResult> {
  const res = await apis.post(`/reviews/from-draft/${draftUuid}`, {
    playbook_uuid: playbookUuid,
    ...opts,
  });
  return res.data as StartReviewFromDocResult;
}

export async function startReviewFromFile(
  fileUuid: string, playbookUuid: string, opts: StartReviewFromDocOptions = {},
): Promise<StartReviewFromDocResult> {
  const res = await apis.post(`/reviews/from-file/${fileUuid}`, {
    playbook_uuid: playbookUuid,
    ...opts,
  });
  return res.data as StartReviewFromDocResult;
}
